<div class="page-wrapper">
    <ng-content></ng-content>
</div>